import { useContext } from 'react';
import { useCreateMachine } from 'fsm';
import { useCurrentUser } from '../CurrentUserProvider';
import { machine } from './machine';
import { buildDefaultCreditsContext } from './util';
import { CreditsContext } from './context';
import { jsx as _jsx } from "react/jsx-runtime";
export const CreditsProvider = ({
  children
}) => {
  const currentUser = useCurrentUser();
  const initialContext = buildDefaultCreditsContext(currentUser);
  const CreditsMachine = useCreateMachine(machine, {
    initialContext,
    isReady: currentUser.isLoaded
  });
  return /*#__PURE__*/_jsx(CreditsContext.Provider, {
    value: CreditsMachine,
    children: children
  });
};
export function useCredits() {
  const context = useContext(CreditsContext);
  if (!context) {
    throw new Error('useCredits must be used within a CreditsProvider');
  }
  const {
    state,
    send
  } = context;
  const {
    availableCredits = 0,
    billingActionDetails,
    breakdown,
    isOverageEnabled,
    monthlyCredits,
    resetDays,
    totalOverage = 0
  } = state.context.data || {};
  const isLoading = state.matches('loadingCredits');
  const isLoaded = state.matches('idle');
  const hasError = state.matches('error');
  const creditsPolicy = state.context.creditsPolicy;
  const hasLowCredits = availableCredits <= 10;
  const usageLimit = (monthlyCredits === null || monthlyCredits === void 0 ? void 0 : monthlyCredits.usageLimit) || 0;
  const totalUsage = (monthlyCredits === null || monthlyCredits === void 0 ? void 0 : monthlyCredits.totalUsage) || 0;
  const updatedAt = monthlyCredits === null || monthlyCredits === void 0 ? void 0 : monthlyCredits.updatedAt;
  const usagePeriod = monthlyCredits === null || monthlyCredits === void 0 ? void 0 : monthlyCredits.usagePeriod;
  const isHubspotCredits = creditsPolicy.hubspotCredits();
  const isIncludedEnrichment = creditsPolicy.includedEnrichment();

  /**
   * @todo refactor to use policy after we pass machine data into the context
   */
  let isAutoUpgradeEnabled = !isOverageEnabled;
  if (isHubspotCredits) {
    isAutoUpgradeEnabled = (billingActionDetails === null || billingActionDetails === void 0 ? void 0 : billingActionDetails.type) === 'TIER_UPGRADE';
  }
  return {
    availableCredits,
    breakdown,
    canEnrichData: creditsPolicy.enrichData(),
    canMonitorIntent: creditsPolicy.monitorIntent(),
    canRunSmartProperty: creditsPolicy.runSmartProperty(),
    canUpgrade: creditsPolicy.billingAccess(),
    creditsPolicy,
    hasError,
    hasLowCredits,
    hasUsage: usageLimit > 0,
    isAutoUpgradeEnabled,
    isIncludedEnrichment,
    isLoaded,
    isLoading,
    isHubspotCredits,
    isOverageEnabled,
    onRefresh: () => send('REFRESH'),
    resetDays,
    shouldUpgrade: !creditsPolicy.platformAccess(),
    showOverage: isOverageEnabled,
    totalOverage,
    totalUsage,
    updatedAt,
    usageLimit,
    usagePeriod
  };
}